export default __webpack_public_path__ + "static/media/project14.54be5f45.png";